export default __webpack_public_path__ + "static/Quickinstallation_Tile_8815_Step_04-6cbf565f9fe7710c5feb448803f16d0e.webp";